import session from './session';

const local_BASE_URL = process.env.VUE_APP_BASE_URL;
console.log('local base URL: ', local_BASE_URL);

export default {
  login(username, password) {
    return session.post(local_BASE_URL + '/dj-rest-auth/login/', { username, password });
  },
  loginWithGoogle(jwt_credentials) {
    console.log("Trying to call loginwithgoogle with jwt_credentials as ", jwt_credentials);
    return session.post(local_BASE_URL + '/loginwithgoogle/', {id_token: jwt_credentials});
  },
  logout() {
    return session.post(local_BASE_URL + '/dj-rest-auth/logout/', {});
  },
  createAccount(username, password1, password2, email) {
    return session.post(local_BASE_URL + '/dj-rest-auth/registration/', { username, password1, password2, email });
  },
  changeAccountPassword(new_password1, new_password2) {
    return session.post(local_BASE_URL + '/dj-rest-auth/password/change/', { new_password1, new_password2 });
  },
  sendAccountPasswordResetEmail(email) {
    console.log("services_auth.js", email)
    // return session.post(local_BASE_URL + '/dj-rest-auth/password/reset/', { email });
    return session.post(local_BASE_URL + '/password_reset/', { email });
  },
  resetAccountPassword(uid, token, new_password1, new_password2) { // eslint-disable-line camelcase
    return session.post(local_BASE_URL + '/dj-rest-auth/password/reset/confirm/', { uid, token, new_password1, new_password2 });
  },
  getAccountDetails() {
    return session.get(local_BASE_URL + '/dj-rest-auth/user/');
  },
  updateAccountDetails(data) {
    return session.patch(local_BASE_URL + '/dj-rest-auth/auth/user/', data);
  },
  verifyAccountEmail(key) {
    return session.post(local_BASE_URL + '/dj-rest-auth/registration/verify-email/', { key });
  },
};